export type ProgramAccent = "leaf" | "cobalt" | "sun" | "violet";

export interface Program {
  slug: string;
  name: string;
  short: string;
  long: string;
  ages: string;
  when: string;
  accent: ProgramAccent;
  ctaLabel: string;
}

export const programs: Program[] = [
  {
    slug: "proyecto-verano",
    name: "Proyecto Verano",
    short: "Campamentos urbanos",
    long: "Campamentos urbanos en julio en las cuatro sedes de Extremadura. Cada día se convierten en un profesional científico distinto: arqueólogo, robotista, química, naturalista. Talleres prácticos donde el aprendizaje se hace jugando.",
    ages: "6–12 años",
    when: "Julio · 9:00 a 14:15",
    accent: "leaf",
    ctaLabel: "Ver matrícula",
  },
  {
    slug: "viaje-al-centro-de-la-ciencia",
    name: "Viaje al Centro de la Ciencia",
    short: "Campamentos de verano temáticos",
    long: "Expediciones temáticas — ANTIQVA, MEDIOEVO, RES PVBLICA, Orígenes — por la geografía extremeña. Una exploración de la ciencia y la tecnología a través de las distintas épocas de la Historia.",
    ages: "11–14 años",
    when: "Verano",
    accent: "cobalt",
    ctaLabel: "Ver ediciones",
  },
  {
    slug: "feria-de-ciencias",
    name: "Feria de Ciencias",
    short: "Concurso anual",
    long: "Concurso en dos fases: locales en cada localidad EMJC y la Gran Final, en una localidad distinta cada año. Los ganadores visitan laboratorios e instalaciones de investigación reales para conocer cómo se hace ciencia profesional.",
    ages: "8–14 años",
    when: "Anual",
    accent: "sun",
    ctaLabel: "Ediciones anteriores",
  },
  {
    slug: "brindis-por-la-ciencia",
    name: "Un Brindis por la Ciencia",
    short: "Conferencia · cata · concierto",
    long: "Ciencia, vino y música. Una conferencia divulgativa de Francisco Fernández de Vega (UEx) acompañada de cata de vinos de la Ribera del Guadiana y mejor jazz extremeño.",
    ages: "Adultos",
    when: "Eventual",
    accent: "violet",
    ctaLabel: "Saber más",
  },
];
